/**
 * @generated SignedSource<<cbf5f793b189f07213e88abe38515e23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSearchQuery$variables = {
  query: string;
};
export type ProductSearchQuery$data = {
  readonly currentStore: {
    readonly productSearch: {
      readonly hits: ReadonlyArray<{
        readonly id: string | null;
        readonly product: {
          readonly id: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ProductSearchListItem_storeProductSearchHit">;
      }>;
    };
  };
};
export type ProductSearchQuery = {
  response: ProductSearchQuery$data;
  variables: ProductSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductSearchQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v1/*: any*/),
              "concreteType": "StoreProductSearchResponse",
              "kind": "LinkedField",
              "name": "productSearch",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreProductSearchHit",
                  "kind": "LinkedField",
                  "name": "hits",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StoreProduct",
                      "kind": "LinkedField",
                      "name": "product",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductSearchListItem_storeProductSearchHit"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreProductSearchResponse",
            "kind": "LinkedField",
            "name": "productSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductSearchHit",
                "kind": "LinkedField",
                "name": "hits",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "partNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductSearchHitHighlightPart",
                    "kind": "LinkedField",
                    "name": "nameHighlights",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isHighlighted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "43b1114fbb0b820cc0ad72eeb64a763e",
    "id": null,
    "metadata": {},
    "name": "ProductSearchQuery",
    "operationKind": "query",
    "text": "query ProductSearchQuery(\n  $query: String!\n) {\n  currentStore {\n    productSearch(query: $query) {\n      hits {\n        id\n        product {\n          id\n        }\n        ...ProductSearchListItem_storeProductSearchHit\n      }\n    }\n    id\n  }\n}\n\nfragment ProductSearchListItem_storeProductSearchHit on StoreProductSearchHit {\n  id\n  nameHighlights {\n    isHighlighted\n    text\n  }\n  product {\n    id\n    imageUrl\n    partNumber\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f00210d5680499e0892d0551b314674";

export default node;
